import { validateDiagram } from './model';
const DB = 'cobygo-diagram-architect';
function open() {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB, 1);
    request.onupgradeneeded = () => { request.result.createObjectStore('diagrams', { keyPath: 'id' }); request.result.createObjectStore('workspace'); };
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(new Error('Local storage is unavailable. Export JSON to keep your work.'));
    request.onblocked = () => reject(new Error('Close other Flow Lens tabs and try again.'));
  });
}
async function transaction(stores, mode, run) {
  const db = await open();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(stores, mode); let result;
    tx.oncomplete = () => { db.close(); resolve(result); };
    tx.onerror = tx.onabort = () => { db.close(); reject(new Error('Could not access local diagrams. Export JSON to keep your work.')); };
    try { run(tx, value => { result = value; }); } catch (e) { tx.abort(); }
  });
}
export const saveDiagram = diagram => {
  const safe = validateDiagram(diagram);
  return transaction(['diagrams', 'workspace'], 'readwrite', tx => { tx.objectStore('diagrams').put(safe); tx.objectStore('workspace').put(safe, 'current'); });
};
export const saveWorkspace = diagram => {
  const safe = validateDiagram(diagram);
  return transaction(['workspace'], 'readwrite', tx => tx.objectStore('workspace').put(safe, 'current'));
};
export const readWorkspace = () => transaction(['workspace'], 'readonly', (tx, done) => { tx.objectStore('workspace').get('current').onsuccess = e => { try { done(e.target.result ? validateDiagram(e.target.result) : null); } catch { tx.abort(); } }; });
export const listDiagrams = () => transaction(['diagrams'], 'readonly', (tx, done) => { tx.objectStore('diagrams').getAll().onsuccess = e => { try { done(e.target.result.map(validateDiagram).sort((a, b) => b.updatedAt - a.updatedAt)); } catch { tx.abort(); } }; });
export const deleteDiagram = id => transaction(['diagrams', 'workspace'], 'readwrite', tx => {
  tx.objectStore('diagrams').delete(id);
  tx.objectStore('workspace').get('current').onsuccess = e => { if (e.target.result?.id === id) tx.objectStore('workspace').delete('current'); };
});
